module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 box1"
  }, [_c('div', {
    staticClass: "hepicture"
  }, [_c('i', {
    staticClass: "backgroundImage"
  }), _vm._v(" "), _c('p', {
    staticClass: "developer_banner_title_01"
  }, [_vm._v(_vm._s(_vm.$t('developer_banner_title_01')))]), _vm._v(" "), _c('p', {
    staticClass: "developer_banner_text_01"
  }, [_vm._v(_vm._s(_vm.$t('developer_banner_text_01')))])]), _vm._v(" "), _c('div', {
    staticClass: "helanguage col-md-12"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "auto",
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "lligence ",
    staticStyle: {
      "margin-left": "10%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hevoice"
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "9px"
    }
  }, [_vm._v(_vm._s(_vm.$t('developer_feature_tool_ai')))]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.$t('developer_feature_tool_description_ai')) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "lligence lligencePaddingStyle"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "hevoice"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('developer_feature_tool_motion')))]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.$t('developer_feature_tool_description_motion')) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "lligence"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "hevoice"
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$t('developer_feature_tool_devtool')))]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.$t('developer_feature_tool_description_devtool')) + "              \n                        ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hepepep col-md-12"
  }, [_c('div', {
    staticClass: "hefowawa"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('developer_feature_step_title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('developer_feature_step_text')))])]), _vm._v(" "), _c('div', {
    staticClass: "heboxea row "
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "heboxea"
  }, [_c('div', {
    staticClass: "heyinye heyinyeMargin"
  }, [_c('div', {
    staticClass: "heaksas"
  }, [_vm._m(3), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('developer_feature_step_sign')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('developer_feature_step_description_sign')))])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "heyinye"
  }, [_c('div', {
    staticClass: "heaksas"
  }, [_vm._m(5), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('developer_feature_step_creat')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('developer_feature_step_description_creat')))])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "heyinye"
  }, [_c('div', {
    staticClass: "heaksas"
  }, [_vm._m(7), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('developer_feature_step_product')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('developer_feature_step_description_product')))])]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "heyinye"
  }, [_c('div', {
    staticClass: "heaksas"
  }, [_vm._m(9), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('developer_feature_step_store')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('developer_feature_step_description_store')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "divBtn"
  }, [_c('button', {
    staticClass: "btnBecomDe",
    on: {
      "click": _vm.btnBecomBtn
    }
  }, [_vm._v(_vm._s(_vm.$t('registerTitle')))])])]), _vm._v(" "), _c('div', {
    staticClass: "technology col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('developer_feature_support_title')))]), _vm._v(" "), _c('div', {
    staticClass: "helogy"
  }, [_c('div', {
    staticClass: "helogy-1"
  }, [_vm._m(10), _vm._v(" "), _c('h4', [_vm._v("Nuwa Robot SDK")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('technicalSupportSdk')))])]), _vm._v(" "), _c('div', {
    staticClass: "helogy-2"
  }, [_vm._m(11), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('technicalSupportAction')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('technicalSupportMotion')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "hegoumai"
  }, [_c('div', {
    staticClass: "heimhsase1"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/home_footer_img.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btnBecomDe positionBuyBtn",
    on: {
      "click": _vm.buyFn
    }
  }, [_vm._v(_vm._s(_vm.$t('buy_now')))]), _vm._v(" "), _c('p', {
    staticClass: "developer_banner_buy"
  }, [_vm._v(_vm._s(_vm.$t('developer_banner_buy')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "imgs1",
    attrs: {
      "src": require("../../static/img/home/home_artificial_intelligence.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "imgs1",
    attrs: {
      "src": require("../../static/img/home/home_body_representation.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "imgs1",
    attrs: {
      "src": require("../../static/img/home/home_development_tools.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imgs"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/home_login_develop.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imhse1"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/home_right.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imgs"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/home_creation_development.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imhse1 imagsAuto"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/home_right.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imgs"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/home_product_validation.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imhse1"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/home_right.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imgs"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/home_mall_release.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imseag1"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/home_robot_sdk.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imseag2"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/home_motion.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-787f902c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info.vue
// module id = 1499
// module chunks = 1